"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var aion_1 = __importDefault(require("@adoratorio/aion"));
var hermes_1 = __importDefault(require("@adoratorio/hermes"));
var declarations_1 = require("./declarations");
var easing_1 = __importDefault(require("./easing"));
var scrollbar_1 = __importDefault(require("./scrollbar"));
var Hades = /** @class */ (function () {
    function Hades(options) {
        var _this = this;
        this._amount = { x: 0, y: 0 };
        this.prevDirection = { x: Hades.DIRECTION.INITIAL, y: Hades.DIRECTION.INITIAL };
        this.prevAmount = { x: 0, y: 0 };
        this.sections = [];
        this.automaticScrolling = false;
        this.imediateScrolling = false;
        this.scrollbar = null;
        this.stopNeedEmission = false;
        this.startNeedEmission = true;
        this.amount = { x: 0, y: 0 };
        this.velocity = { x: 0, y: 0 };
        this.running = false;
        this.still = true;
        var defaults = {
            mode: declarations_1.MODE.VIRTUAL,
            viewport: document.querySelector('.hades-viewport'),
            container: document.querySelector('.hades-container'),
            easing: {
                mode: easing_1.default.LINEAR,
                duration: 1000,
            },
            infiniteScroll: false,
            emitGlobal: true,
            callback: function () { },
            renderByPixel: true,
            lockX: true,
            lockY: false,
            boundries: Hades.createBoundries(0, 0, 0, 0),
            autoBoundries: true,
            sections: false,
            autoplay: true,
            aion: null,
            touchMultiplier: 1.5,
            smoothDirectionChange: false,
            renderScroll: true,
            scrollbar: {
                tracks: [declarations_1.TRACK.Y],
            },
            scale: 1,
        };
        this.options = __assign({}, defaults, options);
        this.timeline = {
            start: 0,
            duration: this.options.easing.duration,
            initial: { x: 0, y: 0 },
            final: { x: 0, y: 0 },
            current: { x: 0, y: 0 },
        };
        this.scrollHandler = function (event) { return _this.scroll(event); };
        this.frameHandler = function (delta) { return _this.frame(delta); };
        if (this.options.viewport === null || typeof this.options.viewport === 'undefined') {
            throw new Error('Viewport cannot be undefined');
        }
        if (this.options.container === null || typeof this.options.container === 'undefined') {
            throw new Error('Container cannot be undefined');
        }
        // If sections are setted load the nodes
        if (this.virtual && this.options.sections) {
            var selector = typeof this.options.sections === 'string' ? this.options.sections : '.hades-section';
            this.sections = Array.from(document.querySelectorAll(selector));
        }
        // Set base css for performance boost
        this.options.container.style.webkitBackfaceVisibility = 'hidden';
        this.options.container.style.backfaceVisibility = 'hidden';
        // Atach and listen to events
        this.manager = new hermes_1.default({
            mode: this.options.mode,
            container: this.options.viewport,
            touchMultiplier: this.options.touchMultiplier,
        });
        this.manager.on(this.scrollHandler);
        // Check and initialize Aion
        if (this.options.autoplay)
            this.running = true;
        if (this.options.aion === null || typeof this.options.aion === 'undefined') {
            this.engine = new aion_1.default();
        }
        else {
            this.engine = this.options.aion;
        }
        if (this.options.scrollbar !== null && this.options.mode === Hades.MODE.VIRTUAL) {
            this.scrollbar = new scrollbar_1.default(this.options.scrollbar, this, this.options.viewport);
        }
        this.engine.add(this.frameHandler, 'hades_frame');
        this.engine.start();
    }
    Hades.prototype.frame = function (delta) {
        var _this = this;
        // If boundires are autosetted use the container dimensions
        if (this.options.autoBoundries) {
            var containerRect = this.options.container.getBoundingClientRect();
            var viewportRect = this.virtual ? this.options.viewport.getBoundingClientRect() : { width: window.innerWidth, height: window.innerHeight };
            this.options.boundries = Hades.createBoundries(0, containerRect.width < viewportRect.width ? 0 : containerRect.width - viewportRect.width, 0, containerRect.height < viewportRect.height ? 0 : containerRect.height - viewportRect.height);
        }
        // Get the new final value
        this.timeline.final.x = this._amount.x;
        this.timeline.final.y = this._amount.y;
        // Normalize delta based on duration
        delta = Math.min(Math.max(delta, 0), this.options.easing.duration);
        // Normalize the delta to be 0 - 1
        var time = delta / this.timeline.duration;
        // Check if the frame is imediate
        if (this.imediateScrolling) {
            time = 1;
            this.imediateScrolling = false;
        }
        // Get the interpolated time
        time = this.options.easing.mode(time);
        // Use the interpolated time to calculate values
        this.timeline.current.x = this.timeline.initial.x + (time * (this.timeline.final.x - this.timeline.initial.x));
        this.timeline.current.y = this.timeline.initial.y + (time * (this.timeline.final.y - this.timeline.initial.y));
        var current = {
            x: this.timeline.current.x,
            y: this.timeline.current.y,
        };
        var roundedCurrent = {
            x: Math.round(this.timeline.current.x),
            y: Math.round(this.timeline.current.y),
        };
        this.amount = this.options.renderByPixel ? roundedCurrent : current;
        // Apply transformation in case of non section method
        if (this.virtual && this.options.renderScroll && !this.options.sections) {
            var px = this.options.lockX ? 0 : this.amount.x * -1;
            var py = this.options.lockY ? 0 : this.amount.y * -1;
            var prop = "translateX(" + px + "px) translateY(" + py + "px) translateZ(0)";
            this.options.container.style.transform = prop;
        }
        // Calculate transform based on prev frame amount and transform if section method
        if (this.virtual && this.options.sections) {
            var sectionsHeight_1 = [];
            this.sections.forEach(function (section) { return sectionsHeight_1.push(section.getBoundingClientRect().height); });
            this.sections.forEach(function (section, index) {
                var rect = section.getBoundingClientRect();
                var prevSectionsHeight = 0;
                for (var i = 0; i < index; i++)
                    prevSectionsHeight += sectionsHeight_1[i];
                // Check if we need to translate this section
                if (_this.prevAmount.y > (prevSectionsHeight - window.innerHeight) &&
                    ((prevSectionsHeight + rect.height) - window.innerHeight) > 0) {
                    var py = _this.amount.y * -1;
                    section.style.transform = "translateY(" + py + "px)";
                }
            });
        }
        // Calculate the speed
        this.velocity = {
            x: Math.abs((current.x - this.prevAmount.x) / delta),
            y: Math.abs((current.y - this.prevAmount.y) / delta),
        };
        // Use 4 digits precision
        this.velocity.x = parseFloat(this.velocity.x.toFixed(4));
        this.velocity.y = parseFloat(this.velocity.y.toFixed(4));
        this.prevAmount = current;
        // Check if the scroll is still animating or not
        if (this.velocity.y === 0 && this.velocity.x === 0) {
            this.still = true;
            if (this.stopNeedEmission) {
                this.emitStillChange('stop');
                this.stopNeedEmission = false;
                this.startNeedEmission = true;
            }
        }
        else {
            this.still = false;
            if (this.startNeedEmission) {
                this.emitStillChange('start');
                this.startNeedEmission = false;
                this.stopNeedEmission = true;
            }
        }
        // Update scrollbar tracks
        if (this.options.scrollbar !== null && this.scrollbar !== null) {
            this.scrollbar.listen(this.amount);
        }
        // Reset the initial position of the timeline for the next frame
        this.timeline.initial = this.timeline.current;
    };
    Hades.prototype.scroll = function (event) {
        // Return if is stopped
        if (!this.running)
            return;
        // Reset from the scroll to if needed
        if (this.automaticScrolling) {
            this.timeline.duration = this.options.easing.duration;
            this.amount = this.prevAmount;
            this.automaticScrolling = false;
        }
        // Multiply the scroll by the options multiplier
        event.delta.x = event.delta.x * this.options.scale;
        event.delta.y = event.delta.y * this.options.scale;
        // Set the first scroll direction
        if (this.prevDirection.x === Hades.DIRECTION.INITIAL || this.prevDirection.y === Hades.DIRECTION.INITIAL) {
            this.prevDirection.x = event.delta.x > 0 ? Hades.DIRECTION.DOWN : Hades.DIRECTION.UP;
            this.prevDirection.y = event.delta.y > 0 ? Hades.DIRECTION.DOWN : Hades.DIRECTION.UP;
        }
        // Temporary sum amount
        var tempX = this._amount.x + event.delta.x;
        var tempY = this._amount.y + event.delta.y;
        // Clamp the sum amount to be inside the boundries if not infinite scrolling
        if (!this.options.infiniteScroll) {
            this._amount.x = Math.min(Math.max(tempX, this.options.boundries.min.x), this.options.boundries.max.x);
            this._amount.y = Math.min(Math.max(tempY, this.options.boundries.min.y), this.options.boundries.max.y);
        }
        else {
            this._amount.x = tempX;
            this._amount.y = tempY;
        }
        // Check the scroll direction
        var currentXDirection = event.delta.x > 0 ? Hades.DIRECTION.DOWN : Hades.DIRECTION.UP;
        var currentYDirection = event.delta.y > 0 ? Hades.DIRECTION.DOWN : Hades.DIRECTION.UP;
        if (!this.options.smoothDirectionChange) {
            if (currentXDirection !== this.prevDirection.x)
                this._amount.x = this.amount.x;
            if (currentYDirection !== this.prevDirection.y)
                this._amount.y = this.amount.y;
        }
        this.prevDirection.x = currentXDirection;
        this.prevDirection.y = currentYDirection;
        // Emit the event and call the callback
        if (this.options.emitGlobal) {
            var eventInit = {};
            eventInit.detail = event;
            var customEvent = new CustomEvent('hades-scroll', eventInit);
            window.dispatchEvent(customEvent);
        }
        this.options.callback(event);
    };
    Hades.prototype.emitStillChange = function (type) {
        if (this.options.emitGlobal) {
            var eventInit = {};
            var customEvent = new CustomEvent("hades-" + type, eventInit);
            window.dispatchEvent(customEvent);
        }
    };
    Hades.prototype.scrollTo = function (position, duration) {
        if (this.virtual) {
            if (duration > 0) {
                this.automaticScrolling = true;
                this.timeline.duration = duration;
            }
            else {
                this.imediateScrolling = true;
            }
        }
        else {
            window.scroll({
                left: position.x,
                top: position.y,
                behavior: duration === 0 ? 'auto' : 'smooth',
            });
        }
        if (typeof position.x !== 'undefined')
            this._amount.x = position.x;
        if (typeof position.y !== 'undefined')
            this._amount.y = position.y;
    };
    Hades.prototype.play = function () {
        this.running = true;
    };
    Hades.prototype.pause = function () {
        this.running = false;
    };
    Hades.prototype.destroy = function () {
        if (this.scrollbar !== null)
            this.scrollbar.destroy();
        this.manager.destroy();
        this.engine.remove('hades_frame');
        delete this.manager;
        delete this.engine;
    };
    Object.defineProperty(Hades.prototype, "virtual", {
        // Common getter for retriving props
        get: function () {
            return this.options.mode === Hades.MODE.VIRTUAL;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Hades.prototype, "fake", {
        get: function () {
            return this.options.mode === Hades.MODE.FAKE;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Hades.prototype, "native", {
        get: function () {
            return this.options.mode === Hades.MODE.NATIVE;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Hades.prototype, "direction", {
        get: function () {
            return this.prevDirection;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Hades.prototype, "boundries", {
        get: function () {
            return this.options.boundries;
        },
        set: function (boundries) {
            this.options.boundries = boundries;
            if (this._amount.y > this.options.boundries.max.y) {
                this.scrollTo({ y: this.options.boundries.max.y }, 0);
            }
            if (this._amount.x > this.options.boundries.max.x) {
                this.scrollTo({ x: this.options.boundries.max.x }, 0);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Hades.prototype, "easing", {
        // Common getters for setting option on the fly
        set: function (easing) {
            this.options.easing = easing;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Hades.prototype, "infiniteScroll", {
        set: function (infiniteScroll) {
            this.options.infiniteScroll = infiniteScroll;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Hades.prototype, "emitGlobal", {
        set: function (emitGlobal) {
            this.options.emitGlobal = emitGlobal;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Hades.prototype, "touchMultiplier", {
        set: function (touchMultiplier) {
            this.options.touchMultiplier = touchMultiplier;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Hades.prototype, "smoothDirectionChange", {
        set: function (smoothDirectionChange) {
            this.options.smoothDirectionChange = smoothDirectionChange;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Hades.prototype, "renderScroll", {
        set: function (renderScroll) {
            this.options.renderScroll = renderScroll;
        },
        enumerable: true,
        configurable: true
    });
    // Some utils
    Hades.createBoundries = function (xMin, xMax, yMin, yMax) {
        var boundries = {
            min: { x: xMin, y: yMin },
            max: { x: xMax, y: yMax }
        };
        return boundries;
    };
    Hades.EASING = easing_1.default;
    Hades.MODE = declarations_1.MODE;
    Hades.DIRECTION = declarations_1.DIRECTION;
    Hades.TRACK = declarations_1.TRACK;
    return Hades;
}());
exports.default = Hades;
